<template>
  <div class="view-wrapper TableViewLayout">
    <div class="Header">
      <div class="TitleWithItems">
        <div class="Title">{{ title }}</div>
        <div class="Items">
          <div v-if="$slots['header-items']" class="Left">
            <slot name="header-items" />
          </div>
          <div v-if="$slots['header-items-right']" class="Right">
            <slot name="header-items-right" />
          </div>
        </div>
      </div>
    </div>
    <div v-if="hasFilters" class="Filters">
      <slot name="filters" />
    </div>
    <div v-if="hasFilterPanelTab" class="Filter-tab-panel">
      <slot name="filter-tab-panel" />
    </div>
    <div
      :class="{ with_filter: hasFilters, empty_table: isEmpty }"
      class="Table"
    >
      <slot />
    </div>
    <slot name="footer" />
  </div>
</template>

<script>
export default {
  name: "TableViewLayout",
  props: {
    title: {
      required: true,
    },
    hasFilterPanelTab: {
      type: Boolean,
      default: false,
    },
    hasFilters: {
      type: Boolean,
      default: false,
    },
    isEmpty: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.TableViewLayout {
  display: flex;
  flex-direction: column;
  position: relative;

  .Header {
    padding-bottom: 26px;

    .TitleWithItems {
      display: flex;
      align-items: center;
      column-gap: 40px;

      .Title {
        color: #0d0e34;
        font-size: 26px;
        line-height: 42px;
        font-weight: 600;
        //white-space: nowrap;
      }

      .Items {
        display: flex;
        column-gap: 30px;
        width: 100%;

        & > .Left,
        & > .Right {
          display: flex;
          column-gap: 30px;
          flex-grow: 1;

          .SearchInput {
            min-width: 150px;
            max-width: 368px;
            box-shadow: 0 0 16px #0000000f;
          }
        }

        & > .Left {
          .SearchInput {
            min-width: 150px;
            max-width: 368px;
            box-shadow: 0 0 16px #0000000f;
          }
        }

        & > .Right {
          display: flex;
          gap: 30px;
          justify-content: end;
          flex-grow: 1;

          .SearchInput {
            min-width: 150px;
            max-width: 300px;
            box-shadow: 0 0 16px #0000000f;
          }
        }

        .Button {
          display: flex;
          align-items: center;
          padding: 9px;
          min-width: 150px;
          background: #1de591;
          color: #ffffff;
          border-radius: 122px;
          cursor: pointer;

          &:hover {
            box-shadow: 0 0 16px #00000029;
          }

          &.IsTiny {
            min-width: unset;

            .Icon {
              margin-right: 0;
            }
          }

          .Icon {
            width: 30px;
            height: 30px;
            margin-right: 22px;
          }

          .Text {
            text-align: center;
          }
        }
      }
    }
  }

  .Filters {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 30px;

    padding: 15px 30px;

    width: 100%;
    height: 110px;
    background: #e6e6e6 0 0 no-repeat padding-box;
    border-radius: 10px 10px 0 0;
  }

  .Filter-tab-panel {
    position: relative;

    padding-top: 16px;

    width: 100%;

    background: #e6e6e6 0 0 no-repeat padding-box;
    border-radius: 10px 10px 0 0;
  }

  .Table {
    display: flex;
    border-radius: 0 0 10px 10px;

    &.with_filter {
      background: #e6e6e6 0 0 no-repeat padding-box;
    }

    &.empty_table {
      flex-grow: 1;
    }

    .table-wrapper {
      min-width: 100%;
    }
  }
}

.filter {
  max-width: 262px;
}
</style>
